import { rangePresets } from '@gogame/intl-ts';

export const permission = 41;

export const SCREEN_NAME = 'gallery-v4';

export const FILTERS = 'filters';
export const TABLE_SETTINGS = 'tableSettings';

export const SEARCH_BY_ID_NAME_TAG = 1;
export const SEARCH_BY_TRANSCRIPTION = 2;
export const SEARCH_BY_EVERYTHING = 3;

export const FILTER_CREATIVES_ADDED = 'creativesAdded';
export const FILTER_CONCEPTS_ADDED = 'conceptsAdded';
export const FILTER_START_PERIOD = 'startPeriod';
export const FILTER_EXPIRATION_PERIOD = 'expirationPeriod';
export const FILTER_APPLICATIONS = 'applications';
export const FILTER_NETWORKS = 'networks';
export const FILTER_STATUSES = 'statuses';
export const FILTER_DESIGNERS = 'authors';
export const FILTER_CREATIVE_TYPES = 'creativeTypes';
export const FILTER_GENRES = 'genres';
export const FILTER_LANGUAGES = 'languages';
export const FILTER_MEDIA_TYPES = 'mediaTypes';
export const FILTER_ORIENTATIONS = 'orientations';
export const FILTER_PRODUCTION_TYPES = 'productionTypes';
export const FILTER_CREATED_BY = 'createdBy';

export const FILTER_REQUESTED_BY = 'requestedBy';
export const FILTER_RESOLUTIONS = 'resolutions';
export const FILTER_RATIOS = 'ratios';

export const FILTER_SIZES = 'sizes';
export const FILTER_ENHANCERS = 'enhancers';
export const FILTER_OS = 'os';
export const FILTER_CHANNELS = 'channels';
export const FILTER_INTERNAL_TAGS = 'internalTags';
export const FILTER_AI_TAGS = 'aiTags';
export const FILTER_EXCLUDED_TAGS = 'excludedTags';
export const FILTER_AI_TAGGING_STATUS = 'aiTagged';
export const FILTER_COMMENTS = 'comments';
export const FILTER_EXCLUSIVE_FOR_AFFILIATES = 'exclusiveForAffiliates';
export const FILTER_TESTED = 'tested';
export const FILTER_AI_GENERATED = 'isAICreated';

export const FILTER_FILTER_BY = 'filterBy';
export const FILTER_CONCEPT_FAMILIES = 'conceptFamilies';
export const FILTER_USED_IN_ADS = 'usedInAds';
export const FILTER_USED_IN_AFFILIATES = 'affiliates';
export const FILTER_LENGTHS = 'length';
export const FILTER_BUSINESS_PARTNERS = 'businessPartners';
export const FILTER_SHARED_WITH = 'sharedWith';
export const FILTER_IS_NEW = 'isNew';
export const FILTER_PROMO_CODES = 'promoCodes';
export const FILTER_OUTSOURCE_STUDIOS = 'outsourceStudios';
export const FILTER_INCLUDE_YT_LINK = 'shouldIncludeYTLink';
export const FILTER_INVERT_AFFILIATE_FILTER = 'invertAffiliateFilter';

export const CREATIVE_TYPE_BANNER = 1;
export const CREATIVE_TYPE_GIF = 2;
export const CREATIVE_TYPE_VIDEO = 3;
export const CREATIVE_TYPE_CINEMAGRAPH = 4;
export const CREATIVE_TYPE_PLAYABLE = 5;

export const UPLOAD_FILE_IMAGE = 'image';
export const UPLOAD_FILE_VIDEO = 'video';
export const UPLOAD_FILE_ZIP = 'zip';

export const STATUS_ACTIVE = 0;
export const STATUS_ARCHIVED = 1;
export const STATUS_PREVIEW = 2;
export const STATUS_PENDING = 3;

export const STATUS_LABELS = {
  [STATUS_PENDING]: 'Pending',
  [STATUS_PREVIEW]: 'Preview',
  [STATUS_ACTIVE]: 'Active',
  [STATUS_ARCHIVED]: 'Archived',
};

export const STATUS_COLORS = {
  [STATUS_PENDING]: 'pending',
  [STATUS_PREVIEW]: 'info',
  [STATUS_ACTIVE]: 'success',
  [STATUS_ARCHIVED]: 'draft',
};

export const TAB_DETAILS = 'details';
export const TAB_ATTACHMENTS = 'attachments';
export const TAB_CREATIVES = 'creatives';
export const TAB_CONCEPTS = 'concepts';
export const TAB_CONCEPT_FAMILIES = 'concept-families';
export const TAB_REVIEWS = 'reviews';
export const TAB_COMMENTS = 'comments';
export const TAB_AI_TAGS = 'ai tags';
export const TAB_PERFORMANCE = 'performance';
export const TAB_ACTIONS_LOG = 'usage log';
export const CREATIVE_ID = 'creativeId';
export const CONCEPT_ID = 'conceptId';
export const CONCEPT_FAMILY_ID = 'conceptFamilyId';

export const EXCEL = 'Excel';
export const ZIP = 'Zip';
export const OVERSIZE_EXPORT_TEXT = 'The limit for downloading is 2 GB.';
export const EXPIRATION_PERIOD_PRESETS = [
  rangePresets.NEXT_2_WEEKS,
  rangePresets.NEXT_MONTH,
  rangePresets.TODAY,
  rangePresets.YESTERDAY,
  rangePresets.DAY_BEFORE_YESTERDAY,
  rangePresets.THIS_WEEK,
  rangePresets.THIS_MONTH,
  rangePresets.THIS_MONTH_MINUS_1,
  rangePresets.THIS_YEAR,
  rangePresets.THIS_PLUS_NEXT_MONTH,
  rangePresets.LAST_3_DAYS,
  rangePresets.LAST_7_DAYS,
  rangePresets.LAST_10_DAYS,
  rangePresets.LAST_14_DAYS,
  rangePresets.LAST_30_DAYS,
  rangePresets.LAST_90_DAYS,
  rangePresets.LAST_180_DAYS,
  rangePresets.LAST_360_DAYS,
  rangePresets.LAST_MONTH,
  rangePresets.LAST_2_MONTHS,
  rangePresets.LAST_3_MONTHS,
  rangePresets.LAST_YEAR,
  rangePresets.LAST_12_MONTHS,
  rangePresets.LIFETIME,
  rangePresets.LIFETIME_PLUS_FUTURE,
];
export const PERIOD_PRESETS = [
  rangePresets.TODAY,
  rangePresets.YESTERDAY,
  rangePresets.DAY_BEFORE_YESTERDAY,
  rangePresets.THIS_WEEK,
  rangePresets.THIS_MONTH,
  rangePresets.THIS_MONTH_MINUS_1,
  rangePresets.THIS_YEAR,
  rangePresets.LAST_3_DAYS,
  rangePresets.LAST_7_DAYS,
  rangePresets.LAST_10_DAYS,
  rangePresets.LAST_14_DAYS,
  rangePresets.LAST_30_DAYS,
  rangePresets.LAST_90_DAYS,
  rangePresets.LAST_180_DAYS,
  rangePresets.LAST_360_DAYS,
  rangePresets.LAST_MONTH,
  rangePresets.LAST_2_MONTHS,
  rangePresets.LAST_3_MONTHS,
  rangePresets.LAST_YEAR,
  rangePresets.LAST_12_MONTHS,
  rangePresets.LAST_12_MONTHS_PLUS_TODAY,
  rangePresets.LIFETIME,
  rangePresets.LIFETIME_PLUS_FUTURE,
];
export const REORDER_COLUMNS = 'REORDER_COLUMNS';
export const COLLAPSE_COLUMNS = 'COLLAPSE_COLUMNS';
export const SCOPE_CREATIVES = 'creatives';
export const SCOPE_CONCEPTS = 'concepts';
export const SCOPE_CONCEPT_FAMILIES = 'conceptFamilies';

export const VIEW_MODE_DATATABLE = 'datatable';
export const VIEW_MODE_TILES = 'tiles';

export const TEMPLATE_BULK_TEMPLATE = 'galleryBulkTemplate';
